import ListTable, {QueryType} from '@component/ListTable'
import CommonService from '@service/commonService'
import '@src/assets/style/main.scss'
import {PersonSelect} from '@src/component/IModal'
import {RejectReasons, USER_SALE} from '@src/constant'
import {goto} from '@src/route'
import {ApplicantVo, QualificationVo} from '@src/type'
import {getItemObj} from '@src/util/store'
import {Button} from 'antd-mobile'
import {Modal, Toast} from 'antd-mobile-v2'
import moment from 'moment'
import React, {useState} from 'react'

type IndexPageStateType = {
    tabKey: number
    style?: any
}
//待申请-待申请、审批中-审批中、驳回-驳回、已通过-已通过、已放款-已放款、已拒绝-已拒绝
const ApplyStatus = [
    {value: '待申请', label: '待申请'},
    {value: '待审核', label: '待审核'},
    {value: '已拒绝', label: '已拒绝'},
    {value: '已过期', label: '已过期'},
]
// 待评估-0、已通过-1、已拒绝-9、已驳回-3
const QualificationStatus = [
    {value: '0,2', label: '待评估'},
    {value: '1', label: '已通过'},
    {value: '3', label: '已驳回'},
    {value: '9', label: '已拒绝'},
    {value: '88', label: '已过期'},
]

export default class IndexPage extends React.Component<any,
    IndexPageStateType> {
    resizeListener?: any

    constructor(props: any) {
        super(props)
        this.state = {
            tabKey: 1,
        }
    }

    componentDidMount() {
        const height = window.innerHeight
        this.setState({
            style: {height: `${height}px`},
        })

        this.resizeListener = () => {
            const height = window.innerHeight
            this.setState({
                style: {height: `${height}px`},
            })
        }
        window.addEventListener('resize', this.resizeListener)
    }

    componentWillUnmount() {
        window.removeEventListener('resize', this.resizeListener)
    }

    logout() {
        Modal.alert('确认退出登录?', '', [
            {text: '取消'},
            {
                text: '退出',
                onPress: () => {
                    CommonService.logout().finally(() => {
                        goto('/login')
                    })
                },
            },
        ])
    }

    getApply(param: QueryType) {
        //
        const queryParam = {
            ...param,
            size: 10,
        }
        return CommonService.applyList(queryParam).then((rs) => {
            return {
                list: rs.rows,
                total: rs.total || 0,
            }
        })
    }

    getQualification(param: QueryType) {
        //待评估-0、已通过-1、已拒绝-9
        const queryParam = {
            ...param,
            size: 10,
        }
        return CommonService.qualificationList(queryParam).then((rs) => {
            return {
                list: rs.rows,
                total: 0,
            }
        })
    }

    onTabClick(mod: number) {
        this.setState({tabKey: mod})
    }

    render() {
        const {tabKey} = this.state
        return (
            <div className="main-page">
                {/* head */}
                <div className="main-head">
                    {/* head title */}
                    {/* <div className="main-head-title-bar">
            <div />
            <div className="title">{user?.dealerName || ''}</div>
            <div onClick={this.logout.bind(this)}>退出</div>
          </div> */}
                    {/* head tab */}
                    <div className="main-head-tab-bar">
                        <div
                            className={tabKey == 1 ? 'bar-item active' : 'bar-item'}
                            onClick={() => this.onTabClick(1)}
                        >
                            资格预审
                        </div>
                        <div
                            className={tabKey == 2 ? 'bar-item active' : 'bar-item'}
                            onClick={() => this.onTabClick(2)}
                        >
                            分期申请
                        </div>
                    </div>
                </div>
                {/* body */}
                <div className="main-body">
                    {/* 资格预审 */}
                    <ListTable
                        action={this.getQualification.bind(this)}
                        // 待评估-0、已通过-1、已拒绝-9
                        statusList={QualificationStatus}
                        render={(e, i, callback) => {
                            return <QualificationItem key={i} data={e} callback={callback}/>
                        }}
                        hide={tabKey !== 1}
                    />
                    {/* 分期申请 */}
                    <ListTable
                        action={this.getApply.bind(this)}
                        statusList={ApplyStatus}
                        render={(e, i) => {
                            return <ApplyItem data={e} key={i}/>
                        }}
                        hide={tabKey !== 2}
                    />
                </div>
            </div>
        )
    }
}

export function QualificationItem(props: {
    data: QualificationVo
    callback: (data?:QualificationVo) => void
}) {
    const {data, callback} = props
    const [selectVisible, setSelectVisible] = useState(false)
    const {isManager, userType} = getItemObj('userInfo')

    const asign = (userId: any) => {
        CommonService.asignByDealerManager({
            qualificationId: data.id,
            salesType: 1,
            managerId: userId,
        }).then(() => {
            Toast.show('操作成功')
            callback?.(data)
        })
    }

    return (
        <>
            <div className="m-list-item" style={{position: 'relative'}}>
                <div className="row">
                    <div className="label name">{data.name}</div>
                    <div className="value">{data.mobile}</div>
                </div>
                <div className="row">
                    <div className="label">申请时间</div>
                    <div className="value">
                        {data.applyTime &&
                        moment(data.applyTime).format('yyyy-MM-DD HH:mm')}
                    </div>
                </div>
                <div className="row">
                    <div className="label">意向车型</div>
                    <div className="value">{data.modelName}</div>
                </div>
                <div className="row">
                    <div className="label">评估进度</div>
                    <div className="value">{data.status}</div>
                </div>
                {data.reason && data.status === '已拒绝' ? (
                    <div className="row">
                        <div className="label">拒绝原因</div>
                        <div className="value">{data.reason}</div>
                    </div>
                ) : null}
                {data.status === '已驳回' && data.reject_type ? (
                    <div className="row">
                        <div className="label">驳回原因</div>
                        <div className="value">{RejectReasons[data.reject_type]}</div>
                    </div>
                ) : null}
                {data.salesInfo && isManager === 1 && (
                    <div className="row">
                        <div className="label">跟单销售</div>
                        <div className="value">{data.salesInfo}</div>
                    </div>
                )}
                {userType === USER_SALE && isManager === 1 && (
                    <Button
                        color="primary"
                        size="small"
                        style={{
                            '--background-color': '#6291DF',
                            position: 'absolute',
                            bottom: 10,
                            right: 10,
                        }}
                        onClick={() => {
                            setSelectVisible(true)
                        }}
                    >
                        指派
                    </Button>
                )}
            </div>
            {selectVisible && isManager === 1 && (
                <PersonSelect
                    visible={selectVisible}
                    onOk={asign}
                    onCancel={() => setSelectVisible(false)}
                />
            )}
        </>
    )
}

export function ApplyItem(props: { data: ApplicantVo }) {
    const {data} = props
    return (
        <div className="m-list-item">
            <div className="row">
                <div className="label name">{data.insuredName}</div>
                <div className="value">{data.mobile}</div>
            </div>
            <div className="row">
                <div className="label">申请时间</div>
                <div className="value">
                    {data.submitTime &&
                    moment(data.submitTime).format('yyyy-MM-DD HH:mm')}
                </div>
            </div>
            <div className="row">
                <div className="label">申请车型</div>
                <div className="value">
                    {data.brandName} {data.vehicleName}
                </div>
            </div>
            <div className="row">
                <div className="label">审批进度</div>
                <div className="value">{data.progress}</div>
            </div>
            <div className="row">
                <div className="label">更新时间</div>
                <div className="value">
                    {data.updateTime &&
                    moment(data.updateTime).format('yyyy-MM-DD HH:mm')}
                </div>
            </div>
            {data.rejectReason && (
                <div className="row">
                    <div className="label">驳回原因</div>
                    <div className="value">{data.rejectReason}</div>
                </div>
            )}
            {data.refusedReason && (
                <div className="row">
                    <div className="label">拒绝原因</div>
                    <div className="value">{data.refusedReason}</div>
                </div>
            )}
        </div>
    )
}
